import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraTelefone,aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialLeadsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  leadForEdit: undefined,
  lastError: null,
  cicloqtde1:0,
  cicloqtde2:0,
  cicloqtde3:0,
  cicloqtde4:0,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const leadsSlice = createSlice({
  name: "leads",
  initialState: initialLeadsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getLeadById
    leadFetched: (state, action) => {


      state.listLoading = false;
      // APLICAR A MASCARA
      state.leadForEdit = action.payload.leadForEdit;
      state.error = null;

    },
    // findLeads
    leadsFetched: (state, action) => {
      const { totalCount, entities ,cicloqtde1,cicloqtde2,cicloqtde3,cicloqtde4} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.cicloqtde1=cicloqtde1;
      state.cicloqtde2=cicloqtde2;
      state.cicloqtde3=cicloqtde3;
      state.cicloqtde4=cicloqtde4;
    },
    // createLead
    leadCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities.push(action.payload.lead);
    },
    // updateLead
    leadUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.lead.id) {
          return action.payload.lead;
        }
        return entity;
      });
    },
    // deleteLead
    leadDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteLeads
    leadsDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // leadsUpdateState
    leadsStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
